/** Align with backend constants/permissions.js and mst_submodules.submodule_slug */
export const PHONE_CALL_LOGS_CONTROL_SUBMODULE_SLUG = "phone-call-logs-control";
export const PHONE_CALL_LOGS_SUBMODULE_SLUG = "phone-call-logs";
